import { useState } from 'react';

const faqItems = [
  {
    question: '我的個人資料安全嗎？',
    answer: '是的。我們採用零信任架構（Zero-Trust Architecture）。您的出生數據與行為參數在傳輸過程中經過加密，僅用於演算法運算。我們不出售或共享任何第三方數據。所有數據傳輸均採用 TLS 1.3 加密。',
  },
  {
    question: '報告需要多長時間交付？',
    answer: '整個流程完全自動化。一旦您通過邀請碼驗證並提交底層出廠設定，非同步引擎通常會在 5 分鐘內將 PDF 戰略報告發送至您的信箱。',
  },
  {
    question: '一個邀請碼可以生成多份報告嗎？',
    answer: '不可以。為維護系統完整性並防止資源濫用，每個授權 Email 在交付後將被鎖定為單一「狀態鎖」。一個邀請碼對應一份完整的 TWINODE 核心戰略報告。',
  },
  {
    question: '這與傳統命理或占星有何不同？',
    answer: '根本性的不同。我們不預測命運，我們計算環境變量與行為機率。我們的 Deno 引擎執行確定性數學運算，GPT-4o 僅作為結構化編譯器將硬編碼參數轉譯為商業策略語言。絕無玄學黑盒，只有可驗證的演算邏輯。',
  },
  {
    question: 'V4.0 Beta 與正式版有何差異？',
    answer: 'Beta 版本為限量 50 席的早期訪問計劃，旨在收集真實用戶反饋以優化系統參數。Beta 用戶將獲得完整的核心報告功能，並享有正式版發布後的優先升級權益。',
  },
];

export default function SecurityFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="security-faq" className="bg-[#050508] text-white py-32 px-6 md:px-12">
      <div className="max-w-3xl mx-auto">
        <div className="mb-16">
          <div className="flex items-center gap-4 mb-5">
            <div className="h-px w-12 bg-[#00ffb4]/20" />
            <span className="font-mono text-[11px] tracking-[0.3em] text-[#00ffb4]/50 uppercase">
              Trust &amp; Compliance
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            常見問題 FAQ
          </h2>
          <p className="text-sm text-white/30 max-w-xl leading-relaxed">
            透明度是不可妥協的原則。以下是關於我們系統最關鍵問題的解答。
          </p>
        </div>

        <div className="space-y-0">
          {faqItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className="border-b border-white/[0.06] last:border-b-0">
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between py-7 text-left cursor-pointer group"
                >
                  <div className="flex items-center gap-5">
                    <span
                      className="font-mono text-[11px] tracking-widest flex-shrink-0 transition-colors duration-200"
                      style={{ color: isOpen ? '#00ffb4' : 'rgba(255,255,255,0.15)' }}
                    >
                      Q{idx + 1}
                    </span>
                    <span className="text-sm font-semibold tracking-wide text-white/70 group-hover:text-white transition-colors duration-200">
                      {item.question}
                    </span>
                  </div>
                  <div
                    className="w-8 h-8 flex items-center justify-center flex-shrink-0 ml-4 transition-transform duration-300"
                    style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
                  >
                    <i className="ri-add-line text-lg text-white/20"></i>
                  </div>
                </button>

                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{ maxHeight: isOpen ? '200px' : '0px', opacity: isOpen ? 1 : 0 }}
                >
                  <div className="pl-[52px] pb-7">
                    <p className="text-sm text-white/40 leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex items-start gap-3 border border-[#00ffb4]/10 rounded px-5 py-4 bg-[#00ffb4]/[0.02]">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-shield-keyhole-line text-sm text-[#00ffb4]/30"></i>
          </div>
          <p className="font-mono text-[11px] text-white/20 leading-relaxed tracking-wide">
            所有數據傳輸均採用 TLS 1.3 加密。管道完成後不存儲任何原始個人數據。系統架構可應要求進行審計。
          </p>
        </div>
      </div>
    </section>
  );
}
